import React from 'react';
import { Row, Col, Skeleton } from 'antd';
import { DotChartOutlined } from '@ant-design/icons';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

export function SkeletonDatailForm() {
	const breakpoints = useBreakpoint();

	return (
		<Row justify="center" align="middle">
			<Col>
				<Skeleton.Node
					active
					style={{
						textAlign: 'center',
						height: `${!breakpoints.xxl ? '150px' : '250px'}`,
						width: `${!breakpoints.xxl ? '400px' : '700px'}`
					}}
				>
					<DotChartOutlined style={{ fontSize: 60, color: '#bfbfbf' }} />
				</Skeleton.Node>
			</Col>
		</Row>
	);
}
